import classNames from 'classnames';
import React from 'react';
import styles from "./media-object.module.css";

/** The MediaObjectImageWrapper component. */
export const MediaObjectImageWrapper = _ref => {
  let {
    className,
    children,
    ...divProps
  } = _ref;
  return /*#__PURE__*/React.createElement("div", Object.assign({}, divProps, {
    className: classNames(className, 'ud-custom-focus-target', styles['image-wrapper'])
  }), children);
};
/** The MediaObjectTitle component. */

export const MediaObjectTitle = _ref2 => {
  let {
    className,
    children,
    ...anchorProps
  } = _ref2;
  return /*#__PURE__*/React.createElement("a", Object.assign({}, anchorProps, {
    className: classNames(className, 'ud-focus-visible-target', styles['media-object-title'])
  }), children);
};
/**
 * The MediaObject component.
 *
 * @privateRemarks
 * This component uses Object.assign to skirt around TypeScript type errors regarding the
 * two components it exposes:
 *
 * - MediaObject.Title the {@link MediaObjectTitle} component
 * - MediaObject.ImageWrapper the {@link MediaObjectImageWrapper} component
 */

export const MediaObject = Object.assign( /*#__PURE__*/React.forwardRef((_ref3, ref) => {
  let {
    className,
    children,
    ...divProps
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", Object.assign({}, divProps, {
    ref: ref,
    className: classNames(className, 'ud-custom-focus-visible', styles['media-object'])
  }), children);
}), {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Title: MediaObjectTitle,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  ImageWrapper: MediaObjectImageWrapper
});
//# sourceMappingURL=media-object.react-component.js.map